module.exports = __webpack_public_path__ + "img/draw_bonus5.0aed7756.png";